/* Hi-Lux product-registration embed.
   Patched fork of https://01f1ef3.netsolhost.com/productregister/assets/js/app.js
   (unchanged upstream since Nov 2017). The legacy server currently appends a PHP
   warning block ("Module 'dom' already loaded") to every response, which broke
   jQuery's strict dataType:"json" parsing and left submits hanging with no
   feedback. This fork parses responses tolerantly, strips the warning markup
   from HTML fragments, and adds error handling. The datepicker init also lives
   here (it was previously an inline script that ran before deferred jQuery). */
jQuery(document).ready(function () {

	/* First-party path: Shopify App Proxy ("Hi-Lux Register Proxy" app) forwards
	   /apps/register/* server-side to the legacy productregister backend, so ad
	   blockers and privacy extensions never see (or block) the third-party host. */
	var baseRegister = '/apps/register';

	// PHP display_errors blocks appended by the legacy server to otherwise-valid output
	var PHP_ERROR_BLOCK = /<div style="border:1px solid #990000[\s\S]*?<\/div>/g;

	function stripPhpErrors(text) {
		return (text || '').replace(PHP_ERROR_BLOCK, '');
	}

	function parseJsonLoose(text) {
		var clean = stripPhpErrors(text).trim();
		try { return JSON.parse(clean); } catch (e) {}
		var m = clean.match(/\{[\s\S]*?\}/);
		if (m) {
			try { return JSON.parse(m[0]); } catch (e) {}
		}
		return null;
	}

	if (jQuery.fn.datepicker) {
		jQuery('.datepicker').datepicker();
	}

	jQuery('#productregister').submit(function (e) {
		e.preventDefault();
		var form = jQuery(this);
		var submitBtn = form.find('button[type="submit"]');
		submitBtn.prop('disabled', true).text('Submitting…');
		jQuery.ajax({
			type: 'POST',
			url: baseRegister + '/storesubmit',
			data: form.serialize(),
			dataType: 'text'
		}).done(function (raw) {
			var response = parseJsonLoose(raw);
			if (response && response.status === 'success') {
				alert(response.message);
				/* Consent is a separate affirmative act: if (and only if) the customer
				   ticked the box, record it on their Shopify customer record via the
				   native newsletter form — the store's consent source of record. */
				var consentBox = document.getElementById('hlx-email-consent');
				var consentForm = document.getElementById('hlx-consent-form');
				if (consentBox && consentBox.checked && consentForm) {
					consentForm.submit();
				} else {
					location.reload(true);
				}
				return;
			}
			alert(response && response.message
				? response.message
				: 'Something went wrong submitting your registration. Please try again, or contact us if it keeps happening.');
			submitBtn.prop('disabled', false).text('Submit');
		}).fail(function () {
			alert("We couldn't reach the registration service. If you use an ad blocker or privacy extension, try disabling it for this site and submitting again — or contact us.");
			submitBtn.prop('disabled', false).text('Submit');
		});
	});

	var $cust_id = jQuery('.myregistered_pro').attr('rel');
	if ($cust_id) {
		jQuery.ajax({
			type: 'GET',
			url: baseRegister + '/storesubmit/regproduct?c=' + $cust_id + '&s=malcolm-optics.myshopify.com',
			dataType: 'html'
		}).done(function (response) {
			jQuery('.myregistered_pro').append(stripPhpErrors(response));
		}).fail(function () {
			jQuery('.myregistered_pro').append(
				'<p style="border:1px solid #ccc;padding:10px;">We couldn\'t load your registered products. ' +
				'If you use an ad blocker or privacy extension, try disabling it for this site and refreshing the page.</p>'
			);
		});
	}

	/* Survey-field handlers carried over from the original embed */
	jQuery('.use_optic.other').click(function () {
		if (this.checked) {
			jQuery('.opticother').attr('required', 'required');
		} else {
			jQuery('.opticother').removeAttr('required');
		}
	});
	jQuery('.currently_pro').click(function () {
		var $val = jQuery("input[name='reg[currently_pro]']:checked").val();
		if ($val == 'Yes') {
			jQuery('.what_pro').attr('required', 'required');
		} else {
			jQuery('.what_pro').removeAttr('required');
		}
	});
	jQuery('#deliveryform').submit(function () {
		jQuery('.submitbutton').attr('disabled', 'disabled');
	});

	var use_opticchecked = 0;
	jQuery('.use_optic').each(function () {
		if (this.checked) {
			use_opticchecked = 1;
			return false;
		}
	});
	if (use_opticchecked == 1) {
		jQuery('.use_optic').removeAttr('required');
	}

	var iamachecked = 0;
	jQuery('.iama').each(function () {
		if (this.checked) {
			iamachecked = 1;
			return false;
		}
	});
	if (iamachecked == 1) {
		jQuery('.iama').removeAttr('required');
	}

	if (jQuery('.other').is(':checked')) {
		jQuery('.opticother').attr('required', 'required');
	}
});

/* Called by inline onClick handlers on the event_join checkboxes */
function deRequire(elClass) {
	el = document.getElementsByClassName(elClass);

	var atLeastOneChecked = false;
	for (i = 0; i < el.length; i++) {
		if (el[i].checked === true) {
			atLeastOneChecked = true;
		}
	}

	if (atLeastOneChecked === true) {
		for (i = 0; i < el.length; i++) {
			el[i].required = false;
		}
	} else {
		for (i = 0; i < el.length; i++) {
			el[i].required = true;
		}
	}
}
